import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userProfile } from "../../store/user/userThunk";

const Protector = ({ Componet }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  let { profile } = useSelector((state) => state.userservice);

  const navigate = useNavigate();
  let dispatch = useDispatch();
  useEffect(() => {
    dispatch(userProfile());
  }, []);

  useEffect(() => {
    const token = Cookies.get("token");
    let twofatoken = Cookies.get("twofatoken");
    if (profile?.is2FAEnabled == true) {
      if (!token || !twofatoken) {
        navigate("/");
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
    } else {
      if (!token) {
        navigate("/");
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
    }
  }, []);

  return <div>{isAuthenticated ? <Componet /> : null}</div>;
};

export default Protector;
